import gql from "graphql-tag";

export const productErrorFragment = gql`
  fragment ProductErrorFragment on ProductError {
    code
    field
    message
  }
`;

export const productErrorWithAttributesFragment = gql`
  ${productErrorFragment}
  fragment ProductErrorWithAttributesFragment on ProductError {
    ...ProductErrorFragment
    attributes
  }
`;

export const accessGroupErrorFragment = gql`
  fragment AccessGroupErrorFragment on AccessGroupError {
    code
    field
    message
  }
`;

export const accountErrorFragment = gql`
  fragment AccountErrorFragment on AccountError {
    code
    field
    message
  }
`;

export const serverErrorFragment = gql`
  fragment ServerErrorFragment on ServerError {
    code
    message
    field
  }
`;

export const brandErrorFragment = gql`
  fragment BrandErrorFragment on BrandError {
    code
    message
    field
  }
`;

export const discountErrorFragment = gql`
  fragment DiscountErrorFragment on DiscountError {
    code
    field
    message
  }
`;

export const bannerErrorFragment = gql`
  fragment BannerErrorFragment on BannerError {
    code
    field
    message
  }
`;

export const menuErrorFragment = gql`
  fragment MenuErrorFragment on MenuError {
    code
    field
  }
`;

export const orderErrorFragment = gql`
  fragment OrderErrorFragment on OrderError {
    code
    field
    message
  }
`;

export const pageErrorFragment = gql`
  fragment PageErrorFragment on PageError {
    code
    field
  }
`;

export const permissionGroupErrorFragment = gql`
  fragment PermissionGroupErrorFragment on PermissionGroupError {
    code
    field
  }
`;

export const bulkProductErrorFragment = gql`
  fragment BulkProductErrorFragment on BulkProductError {
    field
    code
    index
    message
  }
`;
export const bulkStockErrorFragment = gql`
  fragment BulkStockErrorFragment on BulkStockError {
    code
    field
    index
    message
  }
`;
export const stockErrorFragment = gql`
  fragment StockErrorFragment on StockError {
    code
    field
  }
`;

export const shippingErrorFragment = gql`
  fragment ShippingErrorFragment on ShippingError {
    code
    field
    message
  }
`;

export const shopErrorFragment = gql`
  fragment ShopErrorFragment on ShopError {
    code
    field
  }
`;

export const staffErrorFragment = gql`
  fragment StaffErrorFragment on StaffError {
    code
    field
    message
  }
`;

export const warehouseErrorFragment = gql`
  fragment WarehouseErrorFragment on WarehouseError {
    code
    field
    message
  }
`;

export const webhookErrorFragment = gql`
  fragment WebhookErrorFragment on WebhookError {
    code
    field
  }
`;

export const invoiceErrorFragment = gql`
  fragment InvoiceErrorFragment on InvoiceError {
    code
    field
  }
`;

export const appErrorFragment = gql`
  fragment AppErrorFragment on AppError {
    field
    message
    code
    permissions
  }
`;

export const exportErrorFragment = gql`
  fragment ExportErrorFragment on ExportError {
    code
    field
  }
`;

export const pluginErrorFragment = gql`
  fragment PluginErrorFragment on PluginError {
    code
    field
  }
`;

export const metadataErrorFragment = gql`
  fragment MetadataErrorFragment on MetadataError {
    code
    field
  }
`;
export const mallErrorFragment = gql`
  fragment MallErrorFragment on MallError {
    code
    field
    message
  }
`;

export const tenantErrorFragment = gql`
  fragment TenantErrorFragment on TenantError {
    field
    message
    code
  }
`;

export const homeLocationErrorFragment = gql`
  fragment HomeLocationErrorFragment on HomeLocationError {
    field
    message
    code
  }
`;

export const appConfigErrorFragment = gql`
  fragment AppConfigErrorFragment on AppConfigError {
    field
    message
    code
  }
`;

export const couponErrorFragment = gql`
  fragment CouponErrorFragment on DiscountError {
    field
    message
    code
  }
`;

export const remittanceErrorFragment = gql`
  fragment RemittanceErrorFragment on RemittanceError {
    code
    field
    message
  }
`;
